import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', (ev) => {
      ev.preventDefault();

      document.querySelector(`#${this.element.dataset.turboFrame}`).setAttribute('src', this.element.getAttribute('href'));
    });
  }
}